import Axios from '@/utils/axios';
import { OemListRequest, OemListResponse } from '@/types/common';
import { getBackendErrorMessage } from '@/utils/errorHandler';

export interface CreateOEMRequest {
  name: string;
  partnershipStatus: 'ACTIVE' | 'INACTIVE';
  dashboardLink: string;
  dashboardUsername: string;
  dashboardPassword: string;
  createdBy: string;
}

export interface UpdateOEMRequest {
  name: string;
  partnershipStatus: 'ACTIVE' | 'INACTIVE';
  dashboardLink: string;
  dashboardUsername: string;
  dashboardPassword: string;
  updatedBy: string;
}

export interface OemResponse {
  message: string;
  data?: {
    ID: string;
    name: string;
    partnershipStatus: 'ACTIVE' | 'INACTIVE';
    dashboardLink: string;
    dashboardUsername: string;
    dashboardPassword: string;
    createdAt: string;
    updatedAt: string;
    createdBy?: string;
    updatedBy?: string;
  };
}

export const getListOem = async (
  params?: OemListRequest
): Promise<OemListResponse> => {
  try {
    const response = await Axios.get('/v1/oems', { params });
    return response.data;
  } catch (error: unknown) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export const createOEM = async (
  data: CreateOEMRequest
): Promise<OemResponse> => {
  try {
    const response = await Axios.post('/v1/oems', data);
    return response.data;
  } catch (error: unknown) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export const updateOEM = async (
  id: string,
  data: UpdateOEMRequest
): Promise<OemResponse> => {
  try {
    const response = await Axios.patch(`/v1/oems/${id}`, data);
    return response.data;
  } catch (error: unknown) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export interface SettleOemIdleCostRequest {
  // true → mark every unit of this OEM as cost-settled (stop idle cost);
  // false → resume idle cost accrual (undo).
  settled: boolean;
  updatedBy: string;
}

export interface SettleOemIdleCostResponse {
  status: number;
  data?: { affected: number };
}

export const settleOemIdleCost = async (
  id: string,
  data: SettleOemIdleCostRequest
): Promise<SettleOemIdleCostResponse> => {
  try {
    const response = await Axios.patch(`/v1/oems/${id}/settle-idle-cost`, data);
    return response.data;
  } catch (error: unknown) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export const downloadOemsCsv = async (
  params?: OemListRequest
): Promise<Blob> => {
  try {
    const response = await Axios.get('/v1/oems/download/csv', {
      params,
      responseType: 'blob',
    });
    return response.data;
  } catch (error: unknown) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};
